export const GET_COMPOSITION_REQUEST = 'GET_COMPOSITION_REQUEST';
export const GET_COMPOSITION_DATA = 'GET_COMPOSITION_DATA';
export const GET_COMPOSITION_ERROR = 'GET_COMPOSITION_ERROR';

export const CREATE_COMPOSITION_REQUEST = 'CREATE_COMPOSITION_REQUEST';
export const CREATE_COMPOSITION_DATA = 'CREATE_COMPOSITION_DATA';
export const CREATE_COMPOSITION_ERROR = 'CREATE_COMPOSITION_ERROR';

export const UPDATE_COMPOSITION_REQUEST = 'UPDATE_COMPOSITION_REQUEST';
export const UPDATE_COMPOSITION_DATA = 'UPDATE_COMPOSITION_DATA';
export const UPDATE_COMPOSITION_ERROR = 'UPDATE_COMPOSITION_ERROR';

export const DELETE_COMPOSITION_REQUEST = 'DELETE_COMPOSITION_REQUEST';
export const DELETE_COMPOSITION_DATA = 'DELETE_COMPOSITION_DATA';
export const DELETE_COMPOSITION_ERROR = 'DELETE_COMPOSITION_ERROR';
